import styled from 'styled-components'

import { colors } from '../../../constants/colors'
import { USER_TYPES } from '../../../constants/enums'
import { theme } from '../../../constants/theme'

interface CardProps {
  $imagePosition: 'top' | 'left'
}

interface TagProps {
  $userType?: USER_TYPES
  $position?: 'top-right' | 'bottom-left'
}

export const CardContainer = styled.div<CardProps>`
  display: flex;
  flex-direction: ${({ $imagePosition }) =>
    $imagePosition === 'top' ? 'column' : 'row'};
  background: ${colors.white};
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 4px ${theme.effects.shadowOverlay};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
  transition: transform 0.2s ease;
  padding: 10px;

  &:hover {
    transform: ${({ onClick }) => (onClick ? 'translateY(-4px)' : 'none')};
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const TagContainer = styled.div<TagProps>`
  position: absolute;
  ${({ $position = 'top-right' }) =>
    $position === 'top-right'
      ? `
    top: 12px;
    right: 12px;
  `
      : `
    bottom: 12px;
    left: 12px;
  `}
  z-index: 1;
`

export const ImageContainer = styled.div<CardProps>`
  position: relative;
  width: ${({ $imagePosition }) =>
    $imagePosition === 'left' ? '200px' : '100%'};
  height: ${({ $imagePosition }) =>
    $imagePosition === 'top' ? '200px' : '100%'};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    width: ${({ $imagePosition }) =>
      $imagePosition === 'left' ? '100px' : '100%'};
  }
`

export const ContentContainer = styled.div<CardProps>`
  padding: ${({ $imagePosition }) =>
    $imagePosition === 'top' ? '16px 0' : '16px'};
  flex: 1;
  position: relative;
`

export const ArrowContainer = styled.div`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: ${colors.textPrimary};
  opacity: 1;
  transition: opacity 0.2s ease;
  font-size: 20px;
`
